export default __webpack_public_path__ + "static/media/213.75c372dc.jpg";